/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Image_AltInputs */

const en_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Preview`)
};

const fr_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsualisation des sous-titres`)
};

const de_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel-Vorschau`)
};

const it_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima dei sottotitoli`)
};

const ru_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр субтитров`)
};

const es_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de subtítulos`)
};

const zh_cn2_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕预览`)
};

const ja_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕プレビュー`)
};

const hi_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक पूर्वावलोकन`)
};

const pt_pt2_image_export_preview_image_alt = /** @type {(inputs: Image_Export_Preview_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização da legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle Preview" |
*
* @param {Image_Export_Preview_Image_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_image_alt = /** @type {((inputs?: Image_Export_Preview_Image_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Image_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_image_alt(inputs)
	if (locale === "de") return de_image_export_preview_image_alt(inputs)
	if (locale === "it") return it_image_export_preview_image_alt(inputs)
	if (locale === "ru") return ru_image_export_preview_image_alt(inputs)
	if (locale === "es") return es_image_export_preview_image_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_image_alt(inputs)
	if (locale === "ja") return ja_image_export_preview_image_alt(inputs)
	if (locale === "hi") return hi_image_export_preview_image_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_image_alt(inputs)
	return en_image_export_preview_image_alt(inputs)
});